import React, { useState } from 'react';

import Button from '@atlaskit/button';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { trackEvent } from 'src/lib/analytics';

const MenuDropdown = ({ analyticsEvent, title, items, triggerButtonProps }) => {
  const [open, setOpen] = useState(false);
  let trigger = title;

  if (triggerButtonProps) {
    trigger = ({ triggerRef, ...props }) => <Button {...props} isSelected={open} {...triggerButtonProps} ref={triggerRef} />;
  }

  const onDropdownOpen = () => {
    if (analyticsEvent && !open) {
      trackEvent(analyticsEvent, { label: 'open' });
    }
    setOpen(o => !o);
  };

  const onItemClick = (key, action) => {
    if (analyticsEvent) {
      trackEvent(analyticsEvent, { label: key });
    }
    action();
  };
  return (
    <DropdownMenu
      trigger={trigger}
      appearance="tall"
      placement="bottom-end"
      shouldFlip={false}
      onOpenChange={onDropdownOpen}
    >
      <DropdownItemGroup>
        {
          items.map(({ name, key, disabled, action }) => (
            <DropdownItem isDisabled={disabled} key={key} onClick={() => onItemClick(key, action)}>
              {name}
            </DropdownItem>
          ))
        }
      </DropdownItemGroup>
    </DropdownMenu>
  );
};

export default MenuDropdown;
